<template>
    <div>
        <breadcrumb :routerList="[{to:'/rebate',title:'信贷管理'},{title:'客户明细账数据'}]"/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox zhi">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="订单状态">
							    <brselectlazy category="order_status" :v="formInline.status"
							                  v-model="formInline.status" :clearable="true"
							                  />
							</el-form-item>
							<el-form-item label="订单编号">
                <el-input v-model="formInline.sapCode" placeholder="请输入" clearable></el-input>
							</el-form-item>
							<el-form-item label="订单日期" style="width: 50%;">
								<el-date-picker
									v-model="formInline.startCdate"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
								<span class="w-time-to">至</span>
								<el-date-picker
									v-model="formInline.endCdate"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
							</el-form-item>
						</div>
						
						<div class="h-formBtnOut h-columnCenter">
						    <el-button class="h-btn h-formBtn" @click="selectData">检索</el-button>
						    <el-button class="h-btn h-formBtn h-bgwhite" @click="resectData">重置
						    </el-button>
						</div>
                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <div style="background:#fff;width:100%;">
                        <el-table
                                ref="multipleTable"
                                @selection-change="handleSelectionChange"
                                :data="tableData2"
                                stripe
								border
                                style="width: 100%"
                                :default-sort="{prop: 'date', order: 'descending'}"
								max-height="520"
                        >
                            <el-table-column
                                    type="index"
                                    width="40"
                                    label="#"
                                    fixed>
                            </el-table-column>
                            <el-table-column
                                    prop="sapCode"
                                    label="订单编号"
                                    fixed
									:show-overflow-tooltip="true"
                                    width="160">
                            </el-table-column>
                          <el-table-column
                              prop="proModelCode"
                              label="产品编号"
                              width="160">
                          </el-table-column>
                          <el-table-column
                              prop="proModelName"
                              label="产品名称"
                              width="160">
                          </el-table-column>
                          <el-table-column
                              prop="proNumber"
                              label="订单数量"
                              width="160">
                          </el-table-column>
                          <el-table-column
                              prop="totalpricermb"
                              label="订单金额"
                              width="160">
                          </el-table-column>
                          <el-table-column
                              prop="jinexd"
                              label="信贷占用"
                              :show-overflow-tooltip="true"
                              width="140">
                          </el-table-column>
                            <el-table-column
                                    prop="status"
                                    label="订单状态"
									:show-overflow-tooltip="true"
                                    sortable
                                    width="160">
                                <template slot-scope="scope">
                                    {{scope.row.status | dictname('order_status')}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="cdate"
                                    label="创建时间"
									:show-overflow-tooltip="true"
                                    :formatter="formatDatecc"
                                    width="200">
                            </el-table-column>
                        </el-table>
                    </div>

                    <div class="h-tableB h-mrt30">
                        <!--                        <div class="h-tableBL">-->
                        <!--                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import">批量导出</el-button>-->
                        <!--                        </div>-->
                        <div class="h-pagination2">
                            <pagination :page="q" @query="choose"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import customerLedgerService from "../../../api/loud/credit/customerLedgerService";
    import util from "../../../utils/util";

    export default {
        data() {
            return {
                value2: '',
                value3: 36,
                names: '',
                input1: '',
                sele: '工程',
                formInline: {
                    xdid: '',
                  sapCode:null,
                    orderStatus: null,
                    startCdate: null,
                    endCdate: null,
                    moneybackStatus: null,
                    pageSize: 10,
                    pageNo: 1,
                },
                multipleSelection: [],
                tableData2: [],
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0
                },
                creditData: {
                    xdid: '',
                    pageSize: 10,
                    pageNo: 1,
                },
                isCheck: false,
            }
        },
        created() {
            console.log(this.$route.query, '上个页面传来的值')
            this.creditData.xdid = this.$route.query.id;
            this.formInline.xdid = this.$route.query.id;
            //查询该笔信贷对应订单列表
            this.queryOrderList();
        },
        methods: {
          /**
           * 凭证过账日期格式化
           * @param row
           * @param column
           * @returns {string|null}
           */
          formatDatecc(row, column) {
            // 获取单元格数据
            let data = row[column.property]
            if(data == null || data == '') {
              return null
            }
            let dt = new Date(data)
            return this.$util.riQi3(dt);
          },
            timeSelect() {
                this.formInline.startCdate = this.value2[0];
                this.formInline.endCdate = this.value2[1];
            },
            //检索按钮功能
            selectData() {
                this.ischeck = true;
                this.formInline.pageNo = 1;
                this.formInline.pageSize = 10;
                if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.formInline.startCdate))) {
                    if (this.formInline.startCdate !== null) {
                        this.formInline.startCdate = util.riQi3(this.formInline.startCdate);
                    }
                }
                if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.formInline.endCdate))) {
                    if (this.formInline.endCdate !== null) {
                        this.formInline.endCdate = util.riQi3(this.formInline.endCdate);
                    }
                }
                customerLedgerService.queryOrderList(this.formInline).then(response => {
                    console.log(response, '检索结果')
                    this.tableData2 = response.records;
                    this.q.total = response.total;
                })
            },
            selectDataPage() {
                this.ischeck = true;
                if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.formInline.startCdate))) {
                    if (this.formInline.startCdate !== null) {
                        this.formInline.startCdate = util.riQi3(this.formInline.startCdate);
                    }
                }
                if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.formInline.endCdate))) {
                    if (this.formInline.endCdate !== null) {
                        this.formInline.endCdate = util.riQi3(this.formInline.endCdate);
                    }
                }
                customerLedgerService.queryOrderList(this.formInline).then(response => {
                    console.log(response, '检索结果')
                    this.tableData2 = response.records;
                    this.q.total = response.total;
                })
            },
            //重置按钮功能
            resectData() {
                this.value2 = '';
                this.formInline.orderStatus = null;
                this.formInline.startCdate = null;
                this.formInline.endCdate = null;
                this.formInline.sapCode = null;
                this.formInline.moneybackStatus = null;
            },
            //分页按钮功能选择
            choose() {
                if (this.ischeck) {
                    this.formInline.pageNo = this.q.pageNo;
                    this.formInline.pageSize = this.q.pageSize;
                    this.selectDataPage();
                } else {
                    this.queryOrderList();
                }
            },
            //查询该笔信贷对应订单列表
            queryOrderList() {
                this.creditData.pageNo = this.q.pageNo;
                this.creditData.pageSize = this.q.pageSize;
                customerLedgerService.queryOrderList(this.creditData).then(response => {
                    console.log(response, '信贷对应订单列表')
                    this.tableData2 = response.records;
                    this.q.total = response.total;
                })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleSizeChange() {
                console.log(1)
            },
            handleCurrentChange() {
                console.log(2)
            },
            handleScroll(e) {
                console.log(e.target.scrollLeft)
            }
        },
        mounted() {

        }
    }
</script>
<style scoped>

    /* .selectorBox{
        width: 100%;
        padding: 0.54rem 0.28rem 0 0.25rem;
    }
    .selectorBox .text{
        margin-left: 0.38rem;
        font-size: 0.18rem;
        color: #4a4a4a;
        position: relative;
    }
    .selectorBox .text::before{
        content: "*";
        position: absolute;
        top: 0;
        left: -7px;
        color: red;
        font-size: 0.2rem;
    }
    .selectorBox .selector{
        margin-left: 0.38rem;
        margin-top: 20px;
        display: flex;
    }
    .selectorBox .selector .button{
        width: 65px;
        padding: 10px;
        color: #b7b7b7;
        border: 1px solid #dcdfe1;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
    }
    .selectorBox .selector .button.active{
        color: #fff;
        background: #238cfd;
        border: 1px solid #238cfd;
    }
    .tip{
        margin-left: 1.6rem;
        color: #b0b0b0;
        font-size: 0.2rem;
        margin-top:10px;
    }
    .h-bgccc{
        background: #edf5fa;
        border-color: #959595;
        color: #92999e;
    } */
</style>
<style>
    /* .selectorBox .el-input-group__append{
        background: #238cfd;
        color: #fff
    }
    .selectorBox .el-upload-list{
        display: none;
    } */
    /* .h-rowIn .el-table .el-table__body-wrapper::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    } */

    /* .drags .el-slider__button-wrapper .el-slider__button{
        background: url(../../../assets/images/drag.png) center/cover;
        border: 0;
        border-radius: 0;
        width: 20px;
        height: 20px;
    } */
    .zhi .h-formBorder .el-form-item__label {
        vertical-align: top;
    }

    .zhi .el-date-editor .el-range-separator {
        width: 9%;
        margin-bottom: 6px;
    }
</style>